import config from "../config/config";
import axios from "axios";
import { getToken } from "../common";

// Requests to participate: a bidder asks to join an auction, the organiser
// (or an admin) approves or rejects him

const call = (method, path, { data, params } = {}) =>
  axios({
    method,
    url: `${config.api.base_url}${path}`,
    data,
    params,
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      Authorization: getToken(),
    },
  });

// bidder: company details, lots of interest (none = all lots), a note
export const sendJoinRequestAPI = ({
  auctionId,
  company,
  interestedEventItemIds,
  message,
  ipAddress,
}) =>
  call("post", `events/${auctionId}/join-request`, {
    data: { company, interestedEventItemIds, message, ipAddress },
  });

export const withdrawJoinRequestAPI = (auctionId) =>
  call("delete", `events/${auctionId}/join-request`);

// bidder: his requests, newest first, one per auction
export const getMyJoinRequestsAPI = () => call("get", "events/join-requests/mine");

// organiser / admin: one auction's requests (status: PENDING, APPROVED, ...)
export const getJoinRequestsAPI = (auctionId, status) =>
  call("get", `events/${auctionId}/join-requests`, {
    params: status ? { status } : undefined,
  });

// organiser / admin: waiting requests { total, byEvent, latest }
export const getPendingJoinRequestCountsAPI = () =>
  call("get", "events/join-requests/pending-count");

// no lots: approve now, allot lots later
export const approveJoinRequestAPI = (auctionId, eventJoinRequestId, eventItemIds) =>
  call("post", `events/${auctionId}/join-requests/${eventJoinRequestId}/approve`, {
    data: { eventItemIds },
  });

export const rejectJoinRequestAPI = (
  auctionId,
  eventJoinRequestId,
  { reason, allowAnotherRequest }
) =>
  call("post", `events/${auctionId}/join-requests/${eventJoinRequestId}/reject`, {
    data: { reason, allowAnotherRequest },
  });

// admin: every request, with filters
export const getAllJoinRequestsAPI = (params) =>
  call("get", "dashboard/join-requests", { params });

// the server's message for a failed call, or the fallback
export const joinRequestError = (error, fallback) => {
  const reply = error?.response?.data;
  return reply?.message || reply?.error || (typeof reply === "string" && reply) || fallback;
};
